<template>
  <transition name="fade" mode="out-in">
    <div id="sherpaCrmApp" :class="['wrapper', 'w3-row', currentContentId]">
      <div :class="['sherpaCrmAppLoading', {'visible': appLoading}]">
        <spinner-loading :line-size='2' line-fg-color='#5dbecd' />
      </div>
      <div id="sidebar-login" :class="{'w3-third':!isAuthenticated, 'logged':isAuthenticated}">
        <control-panel />
      </div>
      <div id="rest-pantalla" class="Rectangle" :class="{'w3-twothird nologged': !isAuthenticated, 'w3-rest': isAuthenticated, 'closeMenu': !isControlPanelOpen}">
        <div id="content" class="w3-main" :class="{'logged':isAuthenticated}">
          <app-header v-if="isAuthenticated" />

          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </div>
        <back-to-top visibleoffset="400"><i id="back_to_top" class="fa fa-angle-up fa-2x"></i></back-to-top>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import AppHeader from '@/components/appHeader'
import ControlPanel from '@/components/controlPanel'
import * as appTypes from '@/store/actions/app'
import * as authTypes from '@/store/actions/auth'
import * as controlPanelTypes from '@/store/actions/controlPanel'
import store from '@/store'
import { router } from '@/router'
import * as api from '@/utils/api'
import menu from '@/utils/menu'

export default {
  name: 'sherpa-crm-app',
  components: {
    AppHeader,
    ControlPanel
  },
  data () {
    return {
    }
  },
  beforeCreate () {
    // get lang from localStorage cookie
    var lang = localStorage.getItem('lang')
    if (lang) {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_LANGUAGE}`, { lang: lang, ml: this.$ml })
    } else {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_LANGUAGE}`, { lang: Vue.config.sherpaCrm.APP_DEFAULT_LANGUAGE, ml: this.$ml })
    }

    // first browser enter
    // try to login with the last user token
    // and pass the first enter path
    this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_FIRST_CHECK_LOGGED}`, {fullPath: location.pathname})
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`]),
    ...mapGetters(`${controlPanelTypes.CONTROL_PANEL_NAMESPACE}`, [`${controlPanelTypes.CONTROL_PANEL_IS_OPEN}`]),
    ...mapGetters(`${appTypes.APP_NAMESPACE}`, [`${appTypes.APP_CURRENT_CONTENT_ID}`]),
    ...mapGetters(`${appTypes.APP_NAMESPACE}`, [`${appTypes.APP_LOADING}`])
  },
  watch: {
    $route (to, from) {
      if (to.matched.length > 0) {
        var item = to.matched[to.matched.length - 1].props.default
        if (item.type) {
          // 3: APP visible menu levels
          if (to.matched.length <= 3) {
            this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`, item)
            document.getElementsByTagName('html')[0].style.overflowY = 'auto'
          } else {
            var parentItem = to.matched[2].props.default
            this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`, parentItem)
          }
        }
      }
    }
  }
}

// tractar entrada a aplicació
router.beforeEach((to, from, next) => {
  // hide detail container on level 3 or low menu options
  if (to.matched.length < 4) {
    store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_SHOWN}`, false)
  }

  if (to.matched.length > 0) {
    var toItem = to.matched[to.matched.length - 1].props.default
    if (toItem) {
      if (toItem.type) {
        store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true)

        var splittedPath = to.matched[to.matched.length - 1].path.split('/')
        var numPathParams = splittedPath.length - 1
        var lastSplittedPath = splittedPath[splittedPath.length - 1]

        // no detail level
        if (to.matched.length <= 3 && to.matched.length === numPathParams) {
          var item = to.matched[to.matched.length - 1].props.default
          toItem.content = item

          if (to.hash === '') {
            next()
          }

        // detail level or third level width id (single file builders case)
        } else if (to.matched.length > 3 || to.matched.length < numPathParams) {
          var dataId = to.params.id
          // The id is setted by last path param
          if (!dataId && to.matched.length < numPathParams) {
            dataId = lastSplittedPath
          }

          // We go to Detail; open Detail Frame
          if (to.matched.length > 3) {
            store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_SHOWN}`, true)
          }
          var endpoint = toItem.type.endpoint
          var id = toItem.id
          // store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true)
          api.call({access: api.ACCESS_SERVICES, url: endpoint, method: 'POST', data: { id: dataId }})
            .then(resp => {
              store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_CONTENT}`, {resp, endpoint: endpoint, id: id})
              toItem.content = resp
              if (to.hash === '') {
                next()
              }
              store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
            })
            .catch(err => {
              store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_SHOWN}`, false)
              // open error service dialog
              store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, err)
              store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
            })
        }
      } else {
        var contentItem = menu.methods.getDefaultCurrentContent(toItem.subMenu)
        if (contentItem.parentContextPath + contentItem.contextPath !== from.fullPath) {
          store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true)
          router.push(contentItem.parentContextPath + contentItem.contextPath).catch(() => {})
        }
      }
    } else {
      if (to.hash === '') {
        next()
      }
    }
  }
})
</script>

<style src="@fortawesome/fontawesome-free/css/all.min.css"></style>
<style src="vue-definition-utils/dist/vue-multiselect.min.css"></style>
<style src="vuejs-dialog/dist/vuejs-dialog.min.css"></style>
<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>
<style src="element-ui/lib/theme-chalk/index.css"></style>

<style lang="scss">
.sherpaCrmAppLoading {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(120,120,120,0.76);
  z-index: 1000000000000000;
  display: table;
  width: 100%;
  height: 100%;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 0.3s, opacity 0.3s ease;

  > div {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }

  &.visible {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.3s ease;
  }
}

.multiselect__content-wrapper {
  z-index: 100000000000000 !important;
  position: relative !important;
}

div[data-gjs-type="mj-body"] {
  padding-bottom: 20px;
}

html, body,
#sherpaCrmApp {
  height: 100%;

  .w3-modal {
    background-color: rgba(120,120,120,0.76);
  }

  .new {
    #gjs {
      width: auto !important;
      height: auto !important;
      left: 123px;
      right: 0;
      bottom: 75px;
      top: 304px;
      position: fixed;
    }
  }

  .gjs-one-bg {
    background-color: #f8f8f8;
  }
  .gjs-two-color {
    color: #333;
  }
  .gjs-am-preview-cont {
    background-color: transparent;
  }
  .gjs-block {
    border: 1px dashed #ccc;
    min-height: 80px;
    padding: 0.6em 0.6em 1em;
    box-shadow: none;
  }
  .gjs-sm-sector .gjs-sm-field.gjs-sm-composite {
    background-color: #f0f0f0;
    border: 1px solid #e0e0e0;
  }
  .gjs-pn-commands,
  .gjs-pn-views-container {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .gjs-pn-views {
    border-left: 1px solid rgba(0,0,0,0.2);
  }
  .gjs-pn-btn.gjs-pn-active {
    color: #5dbecb;
  }
  .gjs-field {
    background-color: #efefef;
    border: 1px solid #ccc;

    option {
      background-color: #efefef;
    }
  }
  .gjs-dashed {
      outline: 1px dashed rgba(200,200,200,0.7) !important;
      outline-offset: -3px !important;
  }
  #gjs {
    .fa {
      font-family: FontAwesome !important;
    }
  }
  .gjs-dashed #wrapper {
    outline: 0;
  }
  .gjs-block svg {
    width: 45%;
    min-width: 40px;
  }
  .gjs-fonts::before {
    font-size: 4em;
  }

  .gjs-sm-sector .gjs-sm-field input, .gjs-clm-tags .gjs-sm-field input, .gjs-sm-sector .gjs-clm-field input, .gjs-clm-tags .gjs-clm-field input, .gjs-sm-sector .gjs-clm-select input, .gjs-clm-tags .gjs-clm-select input, .gjs-sm-sector .gjs-sm-field select, .gjs-clm-tags .gjs-sm-field select, .gjs-sm-sector .gjs-clm-field select, .gjs-clm-tags .gjs-clm-field select, .gjs-sm-sector .gjs-clm-select select, .gjs-clm-tags .gjs-clm-select select {
    color: rgba(0,0,0,0.7);
  }

  .gjs-select option, .gjs-field-select option, .gjs-clm-select option, .gjs-sm-select option, .gjs-clm-select option, .gjs-fields option, .gjs-sm-unit option {
    color: rgba(0,0,0,0.6);
  }

  .gjs-field-arrow-d,
  .gjs-field .gjs-d-s-arrow {
    border-top: 4px solid rgba(150,150,150,1);
  }
  .gjs-editor-cont .sp-container button, .gjs-editor-cont .sp-container button:hover, .gjs-editor-cont .sp-container button:active {
    color: #555;
  }
  .gjs-field-arrow-u {
    border-bottom: 4px solid rgba(150,150,150,1);
  }

  .definition-wrapper{
    &.text {
      .languageSelectorOrTask {
        float: left;
      }
    }
  }
}
#rest-pantalla {
  height: 100%;

  &.nologged {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    background: url(../assets/media/bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  &.closeMenu {
    #content {
      &.logged {
        left: 135px;
        margin-left: 120px;
      }
    }
  }

  #content {
    height: 100%;
    overflow-y: auto;

    &.logged {
      top: 0;
      right: 0;
      left: 350px;
      width: auto;
      margin-left: 350px;
      transition: all 0.5s;
    }
    &.active {
      margin-left: 150px;
    }

    > .app-container {
      margin-top: 10px;
    }
  }
}

#back_to_top {
  color: #ff7643;
}
.languages {
  /* display: none; */
  position: fixed;
  bottom: 10px;
  right: 0;
  left: 0;
  z-index: 99;
}

.home {
  .timeline {
    margin-top: 0 !important;
    --timelineTheme: #fff !important;

    .repeatable {
      margin-top: 0;
      padding-top: 0;
    }
  }
  .definitionObj {
    &.group {
      .timeline {
        margin: 0 10px;
      }
    }
  }
}
</style>

<style lang="scss">
.tooltip {
  display: block !important;
  z-index: 10000;
  font-size: 12px;

  .tooltip-inner {
    background: #5dbecb;
    color: white;
    border-radius: 9px;
    padding: 5px 15px 5px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #5dbecb;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 6px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

/* Dialog */
.sherpaDialog {
  .dg-backdrop,
  .dg-container {
    z-index: 5000000;
  }
  .dg-backdrop {
    background-color: rgba(0, 0, 0, 0.4)
  }
  .dg-main-content {
    max-width: fit-content;
    border: 0;
    padding: 30px 40px;
    background-color: #342d38;
  }
  .dg-content {
    font-size: 18px;
    font-family: Barlow;
    color: #ffffff;
    text-align: center;
  }
  .dg-content-body {
    border-bottom: 1px dotted #efefef;
  }
  .dg-btn {
    font-family: Capriola;
    font-size: 14px;
    border: 0;
    font-weight: 100;
    transition: all 0.2s ease-in;
  }
  .dg-btn:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
  }
  .dg-btn--cancel {
    background-color: #ffbd42;
    color: #342d38;
    margin-right: 10px;
  }
  .dg-btn--ok {
    background-color: #ff7643;
    color: #fff;
    margin-left: 10px;
  }
  &.sherpaDialogOnlyOk {
    .dg-btn--cancel {
      display: none;
    }
  }
}
.w3-col.w3-10 {
  width: 10%;
}
.w3-col.w3-20 {
  width: 20%;
}
.w3-col.w3-30 {
  width: 30%;
}
.w3-col.w3-40 {
  width: 40%;
}
.w3-col.w3-60 {
  width: 60%;
}
.w3-col.w3-70 {
  width: 70%;
}
.w3-col.w3-80 {
  width: 80%;
}
.w3-col.w3-90 {
  width: 90%;
}

.no-margin-bottom {
  margin-bottom: 0 !important;
}
.no-padding-bottom {
  padding-bottom: 0 !important;
}

.sendemail {
  .taskButton {
     .w3-buttonTask {
       padding: 30px 10px 0 10px;
     }
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/SherpaCrmApp.vue